<template>
  <div>
      <h3>
          Fire Alarm Monthly Testing Record	
      </h3>
      <h4>
        Individual Device Record
        <br>
        (Reference : Clauses 6.6.4.1.4, 6.6.8.1.1-B, CAN/ULC-S536-97)
      </h4>
      <p>
        <b>Notes</b>
        <br>	
        <b>A</b>	Correctly installed
        <br>
        <b>B1</b>	Missing
        <br>
        <b>B2</b>	Requires Service or Repairs
        <br>
        <b>C</b>	Alarm Operation Confirmed
        <br>
        <b>D</b>	Annunciation Indication Confirmed
        <br>
        <b>E</b>	Circuit Number Or Address
        <br>
        <b>F</b>	Supervision and Ground Fault Detection of Wiring to Device Confirmed (Not Required Monthly)
        <br>
        <b>G</b>	Smoke Sensitivity Testing (Not Required Monthly)
      </p>
  </div>
</template>

<script>
export default {
  name : 'AFAS_3_Devices',

}
</script>

<style>

</style>